import { Button } from 'components';
import { PartnerRegistrationForm } from 'components/Forms/Auth/PartnerRegistrationForm';
import { AuthTemplate } from 'components/templates/AuthTemplate';
import { useQueryParams } from 'hooks/useQuery';
import { useDisclose, useError, useLoader } from 'hooks/utilHooks';
import { FC } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import { partnerPreRegistrationValidation } from 'schemas/authValidation';
import { PartnerService } from 'services';
import { IPartnerPreRegistration, TitleByUserRole } from 'types/Auth';

import CloseIcon from '@mui/icons-material/Close';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
} from '@mui/material';

export const PartnerRegistrationPage: FC = () => {
  const { hideLoader, showLoader, loading } = useLoader();
  const { error, hideError, showError } = useError();
  const { isOpen, onOpen } = useDisclose();
  const { replace } = useHistory();
  const { code } = useQueryParams<{ code: string }>();

  const form = useForm<IPartnerPreRegistration>({
    defaultValues: {
      password: '',
      email: '',
      passwordConfirmation: '',
      acceptTerms: { isAccepted: false },
      representativeCode: code,
    },
    resolver: partnerPreRegistrationValidation(),
  });

  document.title = TitleByUserRole.partner;

  const onSubmit = async (values: IPartnerPreRegistration) => {
    try {
      showLoader();
      hideError();

      await PartnerService.partnerSignUp(values);
      onOpen();
    } catch (reason) {
      const { message } = reason as Error;
      showError(message);
    } finally {
      hideLoader();
    }
  };

  const handleClose = () => {
    replace('/partner');
  };

  return (
    <form>
      <FormProvider {...form}>
        <AuthTemplate
          title={TitleByUserRole.partner}
          error={error}
          loading={loading}
          userRole="partner"
        >
          <PartnerRegistrationForm>
            <Button
              fullWidth
              type="submit"
              sx={{ mb: 2 }}
              loading={loading}
              disabled={loading}
              onClick={form.handleSubmit(onSubmit)}
            >
              CADASTRE-SE
            </Button>
          </PartnerRegistrationForm>
        </AuthTemplate>
      </FormProvider>

      <Dialog open={isOpen} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>
          Conta de parceiro criada!
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <DialogContentText>
            Um link de ativação foi enviado para seu e-mail. Verifique sua caixa
            de entrada e spam
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button variant="text" onClick={handleClose}>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </form>
  );
};
